export interface Pet {
  id: string
  name: string
  species: string
  breed: string
  age: string
  birthDate: string
  medal: string
  validUntil: string
  microchip: string
  owner: string
  photo: string
  licenseValid: boolean
}

export interface PetReminder {
  id: string
  label: string
  date: string
  source: 'citoyen' | 'clinique' | 'ville'
}

export interface PetTodo {
  id: string
  title: string
  detail: string
  cta: string
}

export interface Sighting {
  time: string
  label: string
  place: string
}

export const pets: Pet[] = [
  {
    id: 'milo',
    name: 'Milo',
    species: 'Chien',
    breed: 'Golden Retriever',
    age: '4 ans',
    birthDate: '14 mars 2022',
    medal: 'BEA-28421',
    validUntil: '31 décembre 2027',
    microchip: '•••• 4821',
    owner: 'Marianne Caldwell',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/8e5c2f54-519f-4dfa-8746-74e3f7ebc1a3.jpg',
    licenseValid: true,
  },
  {
    id: 'nala',
    name: 'Nala',
    species: 'Chat',
    breed: 'Européen tigré',
    age: '2 ans',
    birthDate: '2 juin 2024',
    medal: 'BEA-30188',
    validUntil: '31 décembre 2026',
    microchip: '•••• 7734',
    owner: 'Marianne Caldwell',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/c60bfb8d-350d-41dd-9813-b9aca392035b.jpg',
    licenseValid: true,
  },
]

export const petTodos: Record<string, PetTodo[]> = {
  milo: [
    {
      id: 'vaccin',
      title: 'Rappel de vaccin',
      detail: 'Vaccin prévu le 14 octobre 2026.',
      cta: 'Voir le rappel',
    },
  ],
  nala: [
    {
      id: 'medaille',
      title: 'Médaille à renouveler',
      detail: 'La licence de Nala expire le 31 décembre.',
      cta: 'Renouveler',
    },
  ],
}

export const petReminders: Record<string, PetReminder[]> = {
  milo: [
    { id: 'vaccin', label: 'Vaccin', date: '14 octobre 2026', source: 'clinique' },
    { id: 'licence', label: 'Renouvellement de la licence', date: '1er décembre 2027', source: 'ville' },
    { id: 'micropuce', label: 'Vérifier l’information de micropuce', date: 'À planifier', source: 'citoyen' },
  ],
  nala: [
    { id: 'licence', label: 'Renouvellement de la licence', date: '1er décembre 2026', source: 'ville' },
    { id: 'vermifuge', label: 'Vermifuge', date: '5 novembre 2026', source: 'citoyen' },
  ],
}

export const sourceLabels: Record<PetReminder['source'], string> = {
  citoyen: 'Rappel ajouté par vous',
  clinique: 'Information partagée par Vet&Cie',
  ville: 'Exigence municipale',
}

export const ruleQuestions = [
  'Puis-je promener Milo sans laisse au parc ?',
  'Combien d’animaux puis-je avoir ?',
  'La médaille est-elle obligatoire pour un chat ?',
  'Quels documents sont nécessaires pour obtenir une médaille ?',
]

export const ruleAnswers: Record<string, string> = {
  'Puis-je promener Milo sans laisse au parc ?':
    'Les chiens doivent être tenus en laisse sur le domaine public, sauf au parc à chiens de la rue Elm, qui compte deux aires séparées selon la taille.',
  'Combien d’animaux puis-je avoir ?':
    'Un maximum de trois animaux par unité d’habitation, dont au plus deux chiens.',
  'La médaille est-elle obligatoire pour un chat ?':
    'Oui. Tout chat et tout chien de plus de trois mois doit porter une médaille valide de la Ville.',
  'Quels documents sont nécessaires pour obtenir une médaille ?':
    'Une preuve de résidence et, s’il y a lieu, le numéro de micropuce. Vos informations de profil sont déjà utilisées.',
}

export const atnaPetQuestions = [
  'Est-ce que la médaille de Milo est encore valide ?',
  'Quand dois-je renouveler sa licence ?',
  'Comment déclarer Milo perdu ?',
  'Quand est son prochain rappel ?',
]

export const sightings: Sighting[] = [
  { time: '15 h 20', label: 'Dernier endroit connu', place: 'Parc Centennial' },
  { time: '15 h 47', label: 'Signalement citoyen', place: 'Chemin Lakeshore' },
  { time: '16 h 05', label: 'Signalement citoyen', place: 'Près du Centre récréatif' },
]
